module.exports = __webpack_public_path__ + "img/vertical_6_7_8017.801a98ac.png";